// document.addEventListener("DOMContentLoaded", function(){
//   const tabs = document.querySelectorAll(".product-tabs__nav button");
//   const contents = document.querySelectorAll(".product-tabs__content");

//   tabs.forEach(tab => {
//     tab.addEventListener("click", function(){
//       tabs.forEach(t => t.classList.remove("active"));
//       contents.forEach(c => c.classList.remove("active"));

//       tab.classList.add("active");
//       document.getElementById(tab.dataset.tab).classList.add("active");
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function(){
  const tabs = document.querySelectorAll(".product-tabs__nav button");
  const contents = document.querySelectorAll(".product-tabs__content");
  const navList = document.querySelector(".product-tabs__nav-list");
  const navContainer = document.querySelector(".product-tabs__nav");

  tabs.forEach(tab => {
    tab.addEventListener("click", function(e){
      if (window.innerWidth <= 768) {
        // If the clicked tab is already active → just toggle dropdown open/close
        if (tab.classList.contains("active")) {
          e.preventDefault();
          navList.classList.toggle("open");
          return; // stop here
        }
      }

      // ---- normal tab switching ----
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      document.getElementById(tab.dataset.tab).classList.add("active");

      // On mobile → close dropdown after selecting
      if (window.innerWidth <= 768) {
        navList.classList.remove("open");
      }
    });
  });

  // close dropdown when clicking outside
  document.addEventListener("click", function(e){
    if (window.innerWidth <= 768 && !navContainer.contains(e.target)) {
      navList.classList.remove("open");
    }
  });
});




